import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import { deleteFromStorage, getFromStorage } from "utils/storage";
import useSize from "@hooks/common/useSize";
import useProfileApi from "./useProfileApi";

const useProfileController = () => {
  const { mutate, isLoading, setDeleteModalOpen, mutateLogOut } =
    useProfileApi();

  const history = useHistory();

  const goToOtherPage = (route) => {
    history.push(route);
  };
  const isUserType = getUserType((state) => state.isUserType);
  const userData = getUserType((state) => state.userData);
  const setUserType = getUserType((state) => state.setUserType);
  const setSelectedProject = generalStore((state) => state.setSelectedProject);
  const selectedProject = generalStore((state) => state.selectedProject);
  const [status, setStatus] = useState("available");
  const deleteModalOpen = generalStore((state) => state.deleteModalOpen);
  const setLogoutLoader = generalStore((state) => state.setLogoutLoader);

  const winDimensions = useSize();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Change Password Modal Pop
  // const [modalOpen, setModalOpen] = React.useState(false);
  // const handleModalOpen = () => setModalOpen(true);
  // const handleModalClose = () => setModalOpen(false);

  const handleLogout = () => {
    setLogoutLoader(true);
    mutateLogOut();
    // setSelectedProject(null);
    // goToOtherPage("/login");
    // deleteFromStorage("user_data");
    // localStorage.clear();
    // // deleteFromStorage("generalStore")
    // setUserType(null);
    // deleteFromStorage("expire")
  };

  const LoginData = getFromStorage("user_data");

  const handleProfileClick = (event) => {
    if (event && event.currentTarget) {
      if (window.innerWidth <= 768) {
        history.push("/profile");
      } else {
        handleClick(event);
      }
    }
  };

  const handleStatusClick = () => {
    const payload = {
      userid: userData?.user_Id,
      status: status,
      projectId: selectedProject,
    };
    mutate(payload);
  };

  const handleStatusChange = (value) => {
    // if (value == "break") {
      setDeleteModalOpen(true);
      setStatus(value);
    // } 
    // else {
    //   const payload = {
    //     userid: userData?.user_Id,
    //     status: value,
    //     projectId: selectedProject,
    //   };
    //   mutate(payload);
    // }
  };

  const handleConfirmModelClose = () => {
    setDeleteModalOpen(false);
    setStatus("");
  };

  return {
    isUserType,
    handleClick,
    handleClose,
    handleLogout,
    // handleModalOpen,
    // handleModalClose,
    handleProfileClick,
    handleStatusChange,
    LoginData,
    winDimensions,
    open,
    // modalOpen,
    anchorEl,
    goToOtherPage,
    handleStatusClick,
    isLoading,
    setDeleteModalOpen,
    deleteModalOpen,
    status,
    handleConfirmModelClose,
  };
};

export default useProfileController;
